import getInitialPlaybackState from "utils/getInitialPlaybackState";

export default function getPlaybackState(state, ownProps) {
  let result;

  if (typeof ownProps.stateKey === "string") {
    result = state.playbackState[ownProps.stateKey];
  } else if (typeof ownProps.chapterId === "number") {
    result = state.playbackState[`chapter-${ownProps.chapterId}`];
  } else {
    throw new Error(
      "getPlaybackState called without `stateKey` or `chapterId`. This causes a dangerous memory leak that will crash the application",
    );
  }

  if (!result) {
    result = getInitialPlaybackState();
  }

  return result;
}

export const makeGetPlaybackState = () => getPlaybackState;
